import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LabsPage from "@/pages/LabsPage";
import FormationPage from "@/pages/FormationPage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import SyntheticsPage from "@/pages/SyntheticsPage";
import JournalPage from "@/pages/JournalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AuthCallback from "@/pages/AuthCallback";
import ProfilePage from "@/pages/ProfilePage";
import AboutPage from "@/pages/AboutPage";
import { CookieBanner } from "@/components/CookieBanner";
import { InstallPWA } from "@/components/InstallPWA";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously (URL fragment #session_id=...)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/labs" element={<LabsPage />} />
      <Route path="/formation" element={<FormationPage />} />
      <Route path="/treatments" element={<TreatmentsPage />} />
      <Route path="/synthetics" element={<SyntheticsPage />} />
      <Route path="/journal" element={<JournalPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <LanguageProvider>
          <BrowserRouter>
            <AppRouter />
            <InstallPWA />
            <CookieBanner />
          </BrowserRouter>
        </LanguageProvider>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
